<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <div class="flex margin-bottom">
      <h1>Styles</h1>
      <div class="margin-left">
        <button :disabled="saving" v-on:click="create">Create</button>
      </div>
    </div>
    <div v-if="showForm" class="margin-bottom filter-boxes padding">
      <MaterialText label="Name" v-model="newStyle.name"></MaterialText>
      <button
          v-on:click="addStyle()"
          :disabled="saving">Save
      </button>
    </div>
    <div class="margin-top">
      <Table :columns="columns" :rows="records" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ProductStyles',
  data: () => ({
    loading: false,
    columns: {
      id: {},
      name: {}
    },
    records: [],
    newStyle: {
      name: ''
    },
    showForm: false
  }),
  methods: {
    load () {
      this.newStyle.name = ''
      this.showForm = false
      Vue.$api.get('/style', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data.map(row => {
        row.menu = [{
          name: 'Delete',
          onClick: row => this.deleteRow(row)
        }]
        return row
      })
    },
    create () {
      this.showForm = true
    },
    deleteRow (row) {
      if (!confirm('Are you sure you want to delete the style?')) {
        return
      }
      Vue.$api.delete('/styles/' + row.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: () => this.load()
      })
    },
    addStyle () {
      if (_.isEmpty(this.newStyle.name)) {
        alert('Name should not be empty')
        return
      }
      Vue.$api.post('/styles', this.newStyle, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: () => this.load()
      })
    }
  },
  created () {
    this.load()
  }
}
</script>

<style scoped>

</style>
